// Filename: SearchBarManager.ts

export interface SearchFilters {
    [key: string]: string; // Dynamic key-value pairs for filters
}

export default function SearchBarManager() {
    return {
        query: '' as string, // The main search query
        filters: {} as SearchFilters, // Holds filter parameters

        /**
         * Updates or adds a filter key-value pair.
         * @param key - The filter key to update.
         * @param value - The value to assign to the filter key.
         */
        setFilter(key: string, value: string): void {
            this.filters[key] = value;
            console.log(`Filter updated: ${key} = ${value}`);
        },

        /**
         * Performs a search using the query and filters.
         * Logs the parameters for now; backend integration can be added here.
         */
        performSearch(): void {
            const params = {
                query: this.query,
                ...this.filters, // Combine the query with all filters
            };

            console.log('Performing search with:', params);

            // Example: Integration with a fetch API call
            // fetch('/api/search', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(params),
            // });
        },
    };
}
